<mat-form-field appearance="outline" class="col-12 py-2">
  <mat-label>{{ translateFieldName(fieldObject) }}</mat-label>
  <input [type]="fieldObject.fieldType" class="form-control " [formControl]="formControlRef"
         [attr.disabled]="(productType === 6 && edit)? true: false" matInput>
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
    {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
  </mat-error>
</mat-form-field>
